import type { StringInventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import type { baseInputs } from "./base";

type stringInputsListFlat = Record<inputsListType, stringInputs>;

export interface stringInputs extends baseInputs {
  type: "text";
  default: string;
}
export type inputsListType = keyof StringInventoryListingConfig;

export const textInputsListFlat: stringInputsListFlat = {
  id: {
    label: "ID",
    type: "text",
    dataIndex: "id",
    disabled: true,
    default: ""
  },
  accountId: {
    dataIndex: "accountId",
    label: "Account ID",
    type: "text",
    disabled: true,
    default: ""
  },
  inventoryId: {
    type: "text",
    dataIndex: "inventoryId",
    label: "Inventory ID",
    disabled: true,
    default: ""
  },
  stickyModels: {
    label: "Sticky Models",
    type: "text",
    dataIndex: "stickyModels",
    default: ""
  },
  selectedModels: {
    dataIndex: "selectedModels",
    label: "Selected Models",
    type: "text",
    default: ""
  },
  excludedModels: {
    dataIndex: "excludedModels",
    label: "Excluded Models",
    type: "text",
    default: ""
  },
  stickyMakes: {
    dataIndex: "stickyMakes",
    label: "Sticky Makes",
    type: "text",
    default: ""
  },
  selectedMakes: {
    dataIndex: "selectedMakes",
    label: "Selected Makes",
    type: "text",
    default: ""
  },
  excludedMakes: {
    dataIndex: "excludedMakes",
    label: "Excluded Makes",
    type: "text",
    default: ""
  },
  stickyModelCodes: {
    type: "text",
    dataIndex: "stickyModelCodes",
    label: "Sticky Model Codes",
    default: ""
  },
  selectedModelCodes: {
    type: "text",
    dataIndex: "selectedModelCodes",
    label: "Selected Model Codes",
    default: ""
  },
  excludedModelCodes: {
    type: "text",
    dataIndex: "excludedModelCodes",
    label: "Excluded Model Codes",
    default: ""
  },
  stickyTrims: {
    type: "text",
    dataIndex: "stickyTrims",
    label: "Sticky Trims",
    default: ""
  },
  selectedTrims: {
    type: "text",
    dataIndex: "selectedTrims",
    label: "Selected Trims",
    default: ""
  },
  excludedTrims: {
    type: "text",
    dataIndex: "excludedTrims",
    label: "Excluded Trims",
    default: ""
  },
  stickyOptionCodes: {
    type: "text",
    dataIndex: "stickyOptionCodes",
    label: "Sticky Option Codes",
    default: ""
  },
  selectedOptionCodes: {
    type: "text",
    dataIndex: "selectedOptionCodes",
    label: "Selected Option Codes",
    default: ""
  },
  excludedOptionCodes: {
    type: "text",
    dataIndex: "excludedOptionCodes",
    label: "Excluded Option Codes",
    default: ""
  },
  stickyBodyStyles: {
    type: "text",
    dataIndex: "stickyBodyStyles",
    label: "Sticky Body Styles",
    default: ""
  },
  selectedBodyStyles: {
    type: "text",
    dataIndex: "selectedBodyStyles",
    label: "Selected Body Styles",
    default: ""
  },
  excludedBodyStyles: {
    type: "text",
    dataIndex: "excludedBodyStyles",
    label: "Excluded Body Styles",
    default: ""
  },
  stickyFuelTypes: {
    type: "text",
    dataIndex: "stickyFuelTypes",
    label: "Sticky Fuel Types",
    default: ""
  },
  selectedFuelTypes: {
    type: "text",
    dataIndex: "selectedFuelTypes",
    label: "Selected Fuel Types",
    default: ""
  },
  excludedFuelTypes: {
    type: "text",
    dataIndex: "excludedFuelTypes",
    label: "Excluded Fuel Types",
    default: ""
  },
  listingAccountId: {
    type: "text",
    dataIndex: "listingAccountId",
    label: "Listing Account ID",
    default: ""
  },
  listingAccountIds: {
    type: "text",
    dataIndex: "listingAccountIds",
    label: "Listing Account IDs",
    default: ""
  },
  defaultSortBy: {
    label: "Default Sort By",
    type: "text",
    dataIndex: "defaultSortBy",
    default: "make,model,trimlevel,year desc"
  },
  // FULLVIEW, LISTVIEW
  defaultView: {
    type: "text",
    dataIndex: "defaultView",
    label: "Default View",
    default: "LISTVIEW"
  },
  compareTarget: {
    type: "text",
    dataIndex: "compareTarget",
    label: "Compare Target",
    default: "_self"
  },
  listingTarget: {
    type: "text",
    dataIndex: "listingTarget",
    label: "Listing Target",
    default: "/vehicle/"
  },
  imagesDirectory: {
    type: "text",
    dataIndex: "imagesDirectory",
    label: "Images Directory",
    default: "/components/listings/classic/silver/"
  },
  calcCustomTerms: {
    dataIndex: "calcCustomTerms",
    label: "Calc Custom Terms",
    type: "text",
    default: ""
  },
  stockNumberStartsWith: {
    type: "text",
    dataIndex: "stockNumberStartsWith",
    label: "Stock Number Starts With",
    default: ""
  },
  stockNumberEndsWith: {
    type: "text",
    dataIndex: "stockNumberEndsWith",
    label: "Stock Number Ends With",
    default: ""
  },
  selectedAccountId: {
    type: "text",
    dataIndex: "selectedAccountId",
    label: "Selected Account ID",
    default: ""
  },
  excludedAccountIds: {
    type: "text",
    dataIndex: "excludedAccountIds",
    label: "Excluded Account IDs",
    default: ""
  },
  sharedExcludedAccountIds: {
    type: "text",
    dataIndex: "sharedExcludedAccountIds",
    label: "Shared Excluded Account IDs",
    default: "true"
  },
  certifiedLogo: {
    type: "text",
    dataIndex: "certifiedLogo",
    label: "Certified Logo",
    default: ""
  }
};

export const isStringInput = (input: baseInputs): input is stringInputs => {
  return input.type === "text";
};
